<template>
  <div
    :meta-error="metaError"
    :class="['input-component w-full relative', extraClass, isActive ? 'is-active' : '', error ? 'is-error' : '']"
  >
    <div class="input relative">
      <input
        v-model="inputValue"
        :placeholder="placeholder"
        :name="name"
        :autocomplete="autocomplete"
        :disabled="disabled"
        type="text"
        class="w-full text-gray-600 h-12.5 border border-sn-gray-400 placeholder-gray-600 text-base px-4 appearance-none outline-none focus:shadow-3"
        :class="[inputClass]"
        @focus="onFocus"
        @blur="onBlur"
        @paste="onPaste"
        @change="onChange"
      >
      <span
        v-if="optional"
        class="optional absolute right-0 bottom-0 top-0  flex items-center mr-3 text-xs text-gray-600 leading-none"
      >
        {{ tr('components.flightVoucher.form.optional') }}
      </span>
    </div>

    <p v-if="error" class="bg-sn-error px-2 pb-1 mt-1">
      <span class="text-white text-xs leading-none">{{ error }}</span>
    </p>
  </div>
</template>

<script>
import TextInput from '~components/shared/text-input'

export default TextInput.extend({})
</script>

<style lang="scss" scoped>
  .input-component {
    &.is-error {
      .input {
        input {
          @apply border-sn-error;
        }
      }
    }
  }

  .is-optional {
    .input-component {
      input {
        padding-right: 75px; /* let's assume that word "optional" has that width in all translations */
      }
    }
  }

  .uppercase.placeholder-normal-case {
    &::-webkit-input-placeholder {
      /* WebKit browsers */
      text-transform: none;
    }

    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      text-transform: none;
    }

    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      text-transform: none;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      text-transform: none;
    }

    &::placeholder {
      /* Recent browsers */
      text-transform: none;
    }
  }
</style>
